import { render, staticRenderFns } from "./UnitDetailsPage.vue?vue&type=template&id=4939bd84&scoped=true"
import script from "./UnitDetailsPage.vue?vue&type=script&lang=js"
export * from "./UnitDetailsPage.vue?vue&type=script&lang=js"
import style0 from "./UnitDetailsPage.vue?vue&type=style&index=0&id=4939bd84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4939bd84",
  null
  
)

export default component.exports